export default __webpack_public_path__ + "static/media/unis.619807b4.png";